import React from "react";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

function SummaryTable({ title, rows, totals, testid }) {
  return (
    <Card className="gold-ring glass overflow-hidden" data-testid={testid}>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="bg-[hsl(var(--primary))]/90 hover:bg-[hsl(var(--primary))]/90">
              <TableHead className="font-700 text-[hsl(var(--primary-foreground))]">{title}</TableHead>
              {["Sailing", "Spot", "SWGP", "Total", "% of members"].map((h) => <TableHead key={h} className="text-right font-700 text-[hsl(var(--primary-foreground))]">{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.label} data-testid={`${testid}-row-${r.label}`}>
                <TableCell className="font-600">{r.label}</TableCell>
                <TableCell className="text-right font-mono-data">{r.Sailing}</TableCell>
                <TableCell className="text-right font-mono-data">{r.Spot}</TableCell>
                <TableCell className="text-right font-mono-data">{r.SWGP}</TableCell>
                <TableCell className="text-right font-mono-data font-700">{r.total}</TableCell>
                <TableCell className="text-right font-mono-data">{r.pct}%</TableCell>
              </TableRow>
            ))}
            <TableRow className="bg-secondary/60 font-700 hover:bg-secondary/60" data-testid={`${testid}-total`}>
              <TableCell>Total</TableCell>
              <TableCell className="text-right font-mono-data">{totals.Sailing}</TableCell>
              <TableCell className="text-right font-mono-data">{totals.Spot}</TableCell>
              <TableCell className="text-right font-mono-data">{totals.SWGP}</TableCell>
              <TableCell className="text-right font-mono-data">{totals.total}</TableCell>
              <TableCell className="text-right font-mono-data">{totals.total ? "100.0" : "0.0"}%</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}

export default function SummaryTables({ stats }) {
  const totals = { ...stats.by_status, total: stats.total };
  return (
    <section data-testid="population-summary">
      <h3 className="mb-3 rounded-md bg-[hsl(var(--primary))] px-3 py-1.5 font-display text-sm font-700 uppercase tracking-wider text-[hsl(var(--primary-foreground))]">Summary tables</h3>
      <div className="space-y-4">
        <SummaryTable title="Designation" rows={stats.designations} totals={totals} testid="summary-designation" />
        <SummaryTable title="Frigate" rows={stats.frigates} totals={totals} testid="summary-frigate" />
      </div>
    </section>
  );
}
